<template lang="pug">
  v-layout.card-icon-duoble-row(:style="{'backgroundColor': dream ? '#0855C4' : 'rgb(45, 179, 152)'}" align-center row fill-height)
    v-dialog(v-model="openDevolucionPopup" persistent width="300")
      v-card(style="display: flex;flex-direction: column;justify-content: center; border-radius:5px")
        v-card-text.pt-3.pb-1
          v-flex(style="text-align:center")
            span {{ textTooltip || 'La suma de tus aportes más rentabilidad.'}}
        v-card-actions.py-3
          v-flex(style="text-align:center")
            v-btn(@click="openDevolucionPopup=false" color="#EA0D90" style="width:10rem;height:2.7rem;border-radius:5px")
              span(style="color:#fff;text-transform:Capitalize" ) ok
    v-flex(style="position:absolute; margin-left:2rem")
      v-img
        img(:src="icon")
    v-flex(pl-2)
      v-layout(column align-center)
        v-flex(style="line-height: 24px;text-align: center;")
          p(v-if="!ocultarMonto") {{text || "S/ 00,000.00" }}
            v-tooltip(bottom max-width="170")
              template(v-slot:activator="{on}")
                img(
                v-if="!dream && $vuetify.breakpoint.width >= 1024"
                v-on="on"
                :src="iconInfoIncognito"
                style="height: 12px;vertical-align: top;margin-left: 0.2rem;margin-top: 0.2rem;position: absolute;"
                )
              span(style="color: #ffffff") {{ textTooltip || 'La suma de tus aportes más rentabilidad.'}}
            img(
              v-if="!dream && $vuetify.breakpoint.width < 1024"
              @click="openDevolucionPopup=true"
              :src="iconInfoIncognito"
              style="height: 12px;vertical-align: top;margin-left: 0.2rem;margin-top: 0.2rem;position: absolute;"
              )
          p(v-if="dream" style="color: #13B9F8") Mi meta 
          p(v-else :style="ocultarMonto ? 'color: #ffffff; font-size: 18px !important;' : 'color: #ffffff;'" style="margin-left: 1rem;") Devolución al {{ formattedDetail }} %
</template>

<script>
export default {
  props: [
    'icon',
    'text',
    'detail',
    'dream',
    'textTooltip',
    'ocultarMonto',
  ],
  data () {
    return {
      iconInfoIncognito: require('./../../assets/icons-mis-seguros/icon-info-incognito.svg'),
      openDevolucionPopup: false
    }
  },
  computed: {
    formattedDetail () {
      const value = Number(this.detail) || 0
      return Number.isInteger(value) ? value : value.toFixed(2)
    }
  },
  mounted () {
    let self = this
  }
}
</script>

<style scoped>
.card-icon-duoble-row p {
  font-family: 'Omnes Regular' !important;
  margin: 0px;
  color: #fff;
}

.card-icon-duoble-row p:first-child {
  font-size: 22px;
}

.card-icon-duoble-row p:last-child {
  font-size: 16px !important;
}

.card-icon-duoble-row {
  position: relative;
  border-radius: 10px;
  margin-top: 8px;
  height: 70px !important;
  max-width: 364px !important;
}
@media screen and (min-width: 1024px) {
  .card-icon-duoble-row {
    margin: 10px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/generic/CardIconTextDoubleRow.vue